import { createBrowserClient } from '@supabase/ssr'

// We export the function AND a singleton instance for non-hook files
export const createClient = () => {
  return createBrowserClient(
    import.meta.env.VITE_SUPABASE_URL!,
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY!
  )
}

// This is what the components are looking for
export const supabase = createClient()